import classnames from 'classnames';
import React, { Component, PropsWithChildren } from 'react';
import { SortableTreeWithoutDndContext as SortableTree } from 'react-sortable-tree';
import getDndSingleManager from '../utils/DefaultDndManager';
import { ITreeProps } from './types';

import './Tree.scss';

export class Tree extends Component<PropsWithChildren<ITreeProps>, {}> {
  context: any;

  public static contextTypes = {
    dragDropManager: () => undefined,
  };

  public static childContextTypes = {
    dragDropManager: () => undefined,
  };

  public getChildContext() {
    return {
      dragDropManager: this.context.dragDropManager || getDndSingleManager(),
    };
  }

  public render() {
    const { className, ...otherprops } = this.props;
    const classes = classnames('hlc-tree', className);
    return <SortableTree className={classes} dndType={'hlcTree'} {...otherprops} />;
  }
}

export default Tree;
